import React, { useRef } from 'react';
import classnames from 'classnames';
import { IconSize } from '../../../Icons/IconWrap';
import NetworkBarItem from '../NetworkBarItem';
import ArrowRight from '../../../Icons/ArrowRight';
import ArrowDown from '../../../Icons/ArrowDown';
import s from './NetworkBarItemGroup.scss';
var NetworkBarItemGroup = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, Icon = _a.icon, isCollapsed = _a.isCollapsed, title = _a.title, withFolding = _a.withFolding, hasNewContent = _a.hasNewContent, isFolded = _a.isFolded, biData = _a.biData, onFoldToggle = _a.onFoldToggle;
    var foldableRef = useRef(null);
    return (React.createElement("div", { className: classnames(s['root'], isCollapsed && s['collapsed'], isFolded && s['folded'], className) },
        React.createElement(NetworkBarItem, { isCollapsed: isCollapsed, icon: React.createElement(Icon, { disableDefaultColors: true, size: IconSize.MEDIUM }), tooltipContent: title, showTooltip: isFolded, biData: biData, onClick: withFolding ? onFoldToggle : undefined, hasNewContent: isFolded && hasNewContent },
            React.createElement("div", { className: s['label'] },
                title,
                withFolding && (React.createElement(React.Fragment, null,
                    ' ',
                    isFolded ? (React.createElement(ArrowRight, { size: IconSize.SMALLER, className: s['arrow'], disableDefaultColors: true })) : (React.createElement(ArrowDown, { size: IconSize.SMALLER, className: s['arrow'], disableDefaultColors: true })))))),
        React.createElement("div", { className: s['foldable'], style: isFolded || !withFolding
                ? {}
                : { maxHeight: (_b = foldableRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight } },
            React.createElement("div", { ref: foldableRef }, children))));
};
NetworkBarItemGroup.displayName = 'NetworkBarItemGroup';
export default NetworkBarItemGroup;
//# sourceMappingURL=NetworkBarItemGroup.js.map